var map = {
	"./1.png": 1199,
	"./2.png": 4151,
	"./Film.mp4": 8602,
	"./Image025.png": 6007,
	"./Image026.png": 8184,
	"./Image027.png": 9205,
	"./JS.mp4": 4015,
	"./but_0000_mute.png": 1102,
	"./but_0001_sound.png": 525,
	"./en-subtitle.vtt": 1791,
	"./koniec.mp3": 5949,
	"./logo.png": 6949,
	"./maximize.png": 1140,
	"./mute.png": 8971,
	"./niepoprawna.mp3": 7154,
	"./pause-button.png": 7513,
	"./play-button (1).png": 6082,
	"./play-button.png": 7660,
	"./poprawna.mp3": 7553,
	"./pyranie.mp3": 9319,
	"./pyt1.mp3": 6786,
	"./pyt2.mp3": 358,
	"./pyt3.mp3": 7053,
	"./quiz_1_pytanie.mp3": 9998,
	"./quiz_2_pytanie.mp3": 1090,
	"./quiz_3_czasmina.mp3": 4040,
	"./quiz_3_pospieszsie.mp3": 8033,
	"./quiz_4_pospieszsie.mp3": 1048,
	"./quiz_5_pospieszsie.mp3": 3995,
	"./quiz_6_dobrze.mp3": 2112,
	"./quiz_7_zle.mp3": 7226,
	"./serce.mp3": 9245,
	"./size_0000_minimalize.png": 4478,
	"./size_0001_maximalize.png": 1525,
	"./subtitles.png": 3577,
	"./subtitles_0000_subtitle_off.png": 6304,
	"./subtitles_0001_subtitle_on.png": 8508,
	"./szybciej.mp3": 6400,
	"./volume.png": 6988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;